import { previewRecommendationsApiSlice } from "./PreviewRecommendations.redux";

export const {
    resetRecommendationsPreviewObject
} = previewRecommendationsApiSlice.actions